export default "__VITE_ASSET__xf$NVsuq__"